import {
  OUT_OF_STOCK_FORM_SUCCESS,
  TOOGLE_AGREEMENT_FIELD_DATA,
  SUBSCRIBED_TO_PRODUCT,
} from './constants';

const initialState = {
  isOpened: true,
  message: null,
  agreementUncheckedState: {},
  agreementDataUrl: '/shop/sitetext/?key=SHOP_BASKET_SALES_AGREEMENT_POPUP',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case TOOGLE_AGREEMENT_FIELD_DATA: {
      return {
        ...state,
        agreementUncheckedState: {
          ...state.agreementUncheckedState,
          ...{ ...action.payload },
        },
      };
    }
    case OUT_OF_STOCK_FORM_SUCCESS: {
      const { isOpened } = action;
      return {
        ...state,
        isOpened,
      };
    }
    case SUBSCRIBED_TO_PRODUCT: {
      const { message, emoji, className } = action;
      return {
        ...state,
        message,
        emoji,
        className,
      };
    }
    default:
      return state;
  }
}
